<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<button type="button" [ngClass]="btnClass" (click)="open()">
  <i [ngClass]="icon"></i>
</button>
